import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import MainButton from '../../../../common/buttons/MainButton';
import EditTimesheetForm from './components/EditTimesheetForm';
import classes from './EditTimesheetModal.module.scss';
import colors from '../../../../../scss/colors';

export default function EditTimesheetModal(props) {
  const {
    open,
    data,
    startDateOfPeriod,
    saveHandler,
    closeHandler,
    allowedWorkTypes,
    rateType,
    deleteLineHandler,
    submissionType,
    currentMonth
  } = props;

  const { t } = useTranslation();

  const timesheetForm = useFormik({
    initialValues: data?.timesheet
  });

  return (
    <Dialog
      open={!!open}
      onClose={closeHandler}
      fullWidth
      sx={{
        '& .MuiPaper-root.MuiDialog-paper': {
          width: 'calc(100% - 24px)',
          maxWidth: '100%',
          margin: '16px'
        },
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          overflowY: 'visible',
          paddingBottom: '16px',
          backgroundColor: colors.PAGE_BACKGROUND
        }
      }}
    >
      <DialogTitle>
        <div role="presentation" onClick={closeHandler} className={classes.threeDotMenu}>
          <CloseIcon fontSize="16px" sx={{ color: colors.ICON_GREY }} />
        </div>
      </DialogTitle>
      <DialogContent>
        <EditTimesheetForm
          isComplexWorktype
          formData={timesheetForm}
          startDateOfPeriod={startDateOfPeriod}
          allowedWorkTypes={allowedWorkTypes}
          rateType={rateType}
          timesheetType={submissionType}
          choosedMonth={currentMonth}
        />
      </DialogContent>
      <DialogActions>
        <div className={classes.actionsContainer}>
          <MainButton
            size="small"
            variant="disabled"
            outlined
            rounded
            action={() => {
              deleteLineHandler(data.timesheet.Id);
              closeHandler();
            }}
            forceWidth="100%"
          >
            {t('common.general.delete')}
          </MainButton>
          <MainButton
            size="small"
            variant={!timesheetForm.dirty ? 'disabled' : 'primary'}
            outlined={false}
            rounded
            disabled={!timesheetForm.dirty}
            action={() => saveHandler(timesheetForm.values)}
            forceWidth="100%"
          >
            {t('common.general.save')}
          </MainButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}
